<template>
  <div>
    <h4>{{ companyName }} {{ $t('report.monthReport')}} - {{ month }}</h4>
    <h5>{{ subTitle }}</h5>
    <h6>{{ date }}</h6>
    <h6>{{ $t('report.version') }}: {{ version }}</h6>
  </div>
</template>

<script>
export default {
  name: 'CoverPage',
  props: {
    companyName: {
      required: false,
      default: () => {}
    },
    month: {
      required: false,
      default: () => {}
    },
    subTitle: {
      required: false,
      default: () => {}
    },
    date: {
      required: false,
      default: ''
    },
    version: {
      required: false,
      default: '1'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reportItems/CoverPage.vue